import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// Components
import AuthPage from './components/auth/AuthPage';
import Dashboard from './components/dashboard/Dashboard';
import AdminDashboard from './components/admin/AdminDashboard';
import LoadingSpinner from './components/common/LoadingSpinner';
import Navbar from './components/layout/Navbar';

// Custom hook for authentication
import { useAuth } from './hooks/useAuth';

function App() {
  const { user, userProfile, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <AnimatePresence mode="wait">
          {!user ? (
            <motion.div
              key="auth"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <AuthPage />
            </motion.div>
          ) : (
            <motion.div
              key="app"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
              className="min-h-screen"
            >
              <Navbar user={userProfile} />
              <main className="pt-16">
                <Routes>
                  <Route
                    path="/"
                    element={
                      userProfile?.role === 'admin' ? (
                        <Navigate to="/admin" replace />
                      ) : (
                        <Navigate to="/dashboard" replace />
                      )
                    }
                  />
                  <Route
                    path="/dashboard"
                    element={
                      userProfile?.role === 'admin' ? (
                        <Navigate to="/admin" replace />
                      ) : (
                        <Dashboard user={userProfile} />
                      )
                    }
                  />
                  <Route
                    path="/admin"
                    element={
                      userProfile?.role === 'admin' ? (
                        <AdminDashboard user={userProfile} />
                      ) : (
                        <Navigate to="/dashboard" replace />
                      )
                    }
                  />
                </Routes>
              </main>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;